"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function TipFilled(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8,1 C11.8659932,1 15,4.13400675 15,8 C15,11.8659932 11.8659932,15 8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 Z M8.75,10 L7.25,10 L7.25,12 L8.75,12 L8.75,10 Z M8.75,4 L7.25,4 L7.25,9 L8.75,9 L8.75,4 Z" })));
}
exports.default = TipFilled;
//# sourceMappingURL=TipFilled.js.map